import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  selectConfigExpressHasMultipleOwners,
  selectConfigExpressRegistrantOptions,
} from '../../store/slices/config/configSelectors';
import { FLOWS_ENUM } from '../../common/enums';
import FlowLayout from 'src/components/layout/FlowLayout';
import { ApplicationData } from 'src/types/flow';
import { ExpressRegistrationRegistrant } from 'src/types/configuration';
import {
  RegistrantForm,
  RegistrantFormProps,
  RegistrantFormRef,
} from 'src/components/form/RegistrantForm';
import {
  setCurrentStep,
  setStepCompletedStatus,
} from 'src/store/slices/flow/flowSlice';
import { useAppDispatch } from 'src/store/store';
import {
  selectCurrentStep,
  selectNextStepPath,
} from 'src/store/slices/flow/flowSelectors';
import usePlaceNavigate from 'src/hooks/usePlaceNavigate';

interface RegistrantPageProps
  extends Pick<RegistrantFormProps, 'allowRoleChange' | 'data'> {
  flow: FLOWS_ENUM;
  updatePermitData: (data: ApplicationData) => void;
}

export const RegistrantPage = ({
  flow,
  updatePermitData,
  ...rest
}: RegistrantPageProps) => {
  const registrantFormRef = useRef<RegistrantFormRef>(null);
  const placeNavigate = usePlaceNavigate();
  const dispatch = useAppDispatch();
  const multipleOwners = useSelector(selectConfigExpressHasMultipleOwners);
  const selectedRegistrantOptions = useSelector(
    selectConfigExpressRegistrantOptions
  );
  const selectedCurrentStep = useSelector(selectCurrentStep);
  const selectedNextStepPath = useSelector(selectNextStepPath);

  const handleNextClick = () => {
    if (registrantFormRef.current?.validateForm()) {
      dispatchRegistrant();
    }
  };

  const dispatchRegistrant = () => {
    const permitData = registrantFormRef.current?.getValues();
    if (permitData) {
      dispatch(updatePermitData(permitData));
      dispatch(
        setStepCompletedStatus({ stepNum: selectedCurrentStep, status: true })
      );
      dispatch(setCurrentStep(selectedCurrentStep + 1));
      placeNavigate('/' + selectedNextStepPath);
    }
  };

  return (
    <FlowLayout
      flow={flow}
      omitNavigationForward
      onNext={handleNextClick}
      showBack
      showNext
      title="Registrant Details"
    >
      <RegistrantForm
        {...rest}
        isAdminUpdate={flow === FLOWS_ENUM.ADMIN_UPDATE}
        multipleOwners={multipleOwners}
        ref={registrantFormRef}
        registrantOptions={
          selectedRegistrantOptions as ExpressRegistrationRegistrant
        }
      />
    </FlowLayout>
  );
};
